import { useNavigate } from '@tanstack/react-router';

import { translate } from '../../common/helpers/translate.helper';
import { useDemandDefinitionReferencePeriodPresets } from '../hooks/useDemandDefinitionReferencePeriodPresets';
import type { DemandDefinitionState } from '../types/DemandDefinitionState';

import { DemandDefinitionEditOverlay } from './DemandDefinitionEditOverlay';
import { DemandDefinitionFlow } from './DemandDefinitionFlow';

interface DemandDefinitionOverlayProps {
    definitionId?: string;
    substep: string;
}

export const DemandDefinitionOverlay = ({ definitionId, substep }: DemandDefinitionOverlayProps) => {
    const navigate = useNavigate();
    const [defaultReferencePeriod] = useDemandDefinitionReferencePeriodPresets();
    const initialDemandDefinition: DemandDefinitionState = {
        adjustments: [],
        fleetChanges: [],
        leavingVessels: [],
        excludedCompanyIds: [],
        excludedProductCategories: [],
        excludedProductKeys: [],
        internalNotes: '',
        name: '',
        reference: '',
        referencePeriodFrom: defaultReferencePeriod.from,
        referencePeriodTo: defaultReferencePeriod.to,
    };

    const closeOverlay = (customerGroupId?: string) => {
        navigate({
            to: '/demand-definitions',
            search: { customerGroupId },
        });
    };

    if (definitionId) {
        return <DemandDefinitionEditOverlay definitionId={definitionId} onClose={closeOverlay} substep={substep} />;
    }

    return (
        <DemandDefinitionFlow
            initialDemandDefinition={initialDemandDefinition}
            onClose={closeOverlay}
            overlayTitle={translate('demandDefinition.createDemandDefinition')}
            substep={substep}
        />
    );
};
